import { c as _c } from "react/compiler-runtime";
import { IconCircleArrowLeft, IconCircleArrowRight } from "@tabler/icons-react";
import Link from "next/link";
import { BlogPostDirection } from "@/constants/BlogPostDirection";
import type { BlogPostLink } from "@/types/contentful/BlogPostLink";
interface Props {
  post: BlogPostLink;
  direction: BlogPostDirection;
}
export const BlogNavLink = t0 => {
  const $ = _c(17);
  const {
    post,
    direction
  } = t0;
  const isPrevious = direction === BlogPostDirection.Previous;
  const label = isPrevious ? "Previous Article" : "Next Article";
  const t1 = `/blog/${post.slug}`;
  const t2 = `${label}: ${post.headline}`;
  let t3;
  if ($[0] !== isPrevious) {
    t3 = isPrevious && <IconCircleArrowLeft size={40} stroke={1.5} className="shrink-0 mt-0.5" />;
    $[0] = isPrevious;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== label) {
    t4 = <span className="text-xs font-normal leading-4">{label}</span>;
    $[2] = label;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== post.headline) {
    t5 = <span className="text-xl font-bold leading-7 group-hover:opacity-70 transition-opacity">{post.headline}</span>;
    $[4] = post.headline;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <div className="flex flex-col gap-1">{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isPrevious) {
    t7 = !isPrevious && <IconCircleArrowRight size={40} stroke={1.5} className="shrink-0 mt-0.5" />;
    $[9] = isPrevious;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t6 || $[15] !== t7) {
    t8 = <Link href={t1} className="flex items-start gap-3 no-underline! group text-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 rounded-sm" aria-label={t2}>{t3}{t6}{t7}</Link>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};